/**
 * Chart Color Palette
 * Salesforce Lightning Design System inspired colors for all charts
 */

export const CHART_COLORS = {
  // Salesforce primary blues
  salesforceBlue: '#0176D3',    // Primary Salesforce blue
  electricBlue: '#1B96FF',      // Bright blue
  skyBlue: '#00A1E0',           // Sky blue
  darkBlue: '#032E61',          // Dark blue

  // Chart data colors (Salesforce palette)
  teal: '#06AED5',              // Teal
  purple: '#9050E9',            // Purple
  orange: '#FF9A3C',            // Orange
  green: '#3BA755',             // Green
  pink: '#E3066A',              // Pink
  yellow: '#FFB95C',            // Yellow
  red: '#EA001E',               // Red

  // Grayscale (for text, borders, backgrounds)
  black: '#080707',             // Near black
  charcoal: '#032E61',          // Dark blue (reused)
  darkGray: '#3E3E3C',          // Dark gray
  gray: '#706E6B',              // Medium gray
  mediumDark: '#1B96FF',        // Electric blue (reused)
  mediumLight: '#00A1E0',       // Sky blue (reused)
  lightGray: '#C9C7C5',         // Light gray
  silverGray: '#DDDBDA',        // Silver gray

  // Background colors
  blueLight: '#D8E6FE',         // Light blue background
  grayLight: '#F3F3F3',         // Light gray background

  // Semantic colors
  success: '#3BA755',           // Green (reused)
  warning: '#FFB95C',           // Yellow (reused)
  error: '#EA001E',             // Red (reused)
  info: '#0176D3',              // Salesforce blue (reused)

  // Utility colors
  border: '#DDDBDA',            // Border color
  text: '#080707',              // Text color
  textLight: '#706E6B',         // Light text

  // Legacy compatibility - map to Salesforce colors
  blue: '#0176D3',              // Salesforce blue
} as const;

// Chart series colors (for multiple series in same chart)
// Using Salesforce's recommended chart colors
export const CHART_SERIES = [
  CHART_COLORS.salesforceBlue,  // #0176D3
  CHART_COLORS.orange,          // #FF9A3C
  CHART_COLORS.teal,            // #06AED5
  CHART_COLORS.purple,          // #9050E9
  CHART_COLORS.green,           // #3BA755
  CHART_COLORS.pink,            // #E3066A
  CHART_COLORS.yellow,          // #FFB95C
  CHART_COLORS.skyBlue,         // #00A1E0
];

// Financial chart colors (standardized across app)
// Using Salesforce color hierarchy for financial data
export const FINANCIAL_COLORS = {
  revenue: CHART_COLORS.salesforceBlue,    // Primary Salesforce blue for revenue
  expenses: CHART_COLORS.orange,           // Orange for expenses
  noi: CHART_COLORS.green,                 // Green for NOI (positive metric)
  debtService: CHART_COLORS.purple,        // Purple for debt service
  cashFlow: CHART_COLORS.teal,             // Teal for cash flow
  equity: CHART_COLORS.electricBlue,       // Electric blue for equity
  debt: CHART_COLORS.pink,                 // Pink for debt
  development: CHART_COLORS.yellow,        // Yellow for development
} as const;
